
function wrapUpdateCall( ctx, optionsFunc ) {
    return async function( results ) {
        if ( !optionsFunc || typeof optionsFunc !== 'function' ) {
            throw new Error( 'options function required to wrap update call' );
        }

        const options = optionsFunc( results );

        return await ctx.update( options.options, options.meta, ctx.abortController.signal );
    };
}

export {
    wrapUpdateCall,
};
